import { supabase } from "@/lib/supabaseClient";
import type {
  Membership,
  MembershipInsert,
  MembershipWithOrg,
} from "@/lib/supabase/types";

export async function createMembership(input: MembershipInsert): Promise<Membership> {
  const { data, error } = await supabase
    .from("memberships")
    .insert(input)
    .select()
    .single();
  if (error) throw error;
  return data;
}

/** All orgs the current user belongs to, each with its org record inlined.
 *  Used by AuthContext to populate currentOrg after sign-in. */
export async function listMyMemberships(): Promise<MembershipWithOrg[]> {
  const { data, error } = await supabase
    .from("memberships")
    .select("*, organization:organizations(*)")
    .eq("status", "active");
  if (error) throw error;
  // Supabase's auto-relation inference gives `organization` as either
  // array or single depending on FK cardinality — coerce to single since
  // memberships.org_id is many-to-one.
  return (data ?? []).map((row) => ({
    ...(row as Membership),
    organization: (row as any).organization,
  }));
}
